import type { FetchFunction } from 'relay-runtime';
import FeatureGates from '@atlassian/feature-gate-js-client';
import { fetchJson } from '@atlassian/help-center-common-util/fetch';

const fetchQuery: FetchFunction = ({ text, operationKind, id }, variables) => {
    const isPersistedQueriesEnabled = FeatureGates.checkGate('jsm_portal_persisted_queries');
    const AGG_BASE_PATH = isPersistedQueriesEnabled && id ? `/gateway/api/graphql/pq/${id}` : '/gateway/api/graphql';
    const AGG_PATH = process.env.AGG_BRANCH_SLUG
        ? `${AGG_BASE_PATH}/${process.env.AGG_BRANCH_SLUG}/graphql`
        : AGG_BASE_PATH;
    const body = JSON.stringify({
        variables,
        query: text, //TODO: remove this line after moving to persisted queries completely
    });

    return fetchJson(AGG_PATH, {
        body,
        method: 'POST',
        headers: {
            'Content-type': 'application/json',
            ...(operationKind === 'mutation' && {
                'X-ExperimentalApi': 'help-object-store-agg-beta, HelpCenterReorderTopics',
            }),
        },
    });
};

export default fetchQuery;
